import type {LoginFormEmailValues, LoginFormPhoneValues} from '../LoginForm';
import {normalizePhone} from './normalizePhone';

type AuthBodyData =
  | {
      phone: string;
      password: string;
    }
  | {
      email: string;
      password: string;
    };

export const prepareBodyDataEmail = (data: LoginFormEmailValues): AuthBodyData => {
  const {email, password} = data;

  // простая проверка на email
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  if (isEmail) {
    return {email: email?.trim(), password};
  }

  // иначе считаем это телефоном
  return {phone: normalizePhone(email?.trim()), password};
};

export const prepareBodyDataPhone = (data: LoginFormPhoneValues): AuthBodyData => {
  const {phone, password} = data;

  // простая проверка на email
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(phone);

  if (isEmail) {
    return {email: phone?.trim(), password};
  }

  // иначе считаем это телефоном
  return {phone: normalizePhone(phone?.trim()), password};
};
